import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { InformesComponent } from "./informes/informes.component";
import { InformeMovimientosComponent } from "./informe-movimientos/informe-movimientos.component";

const routes: Routes = [
  {
    path: "",
    pathMatch: "full",
    component: InformesComponent,
  },
  {
    path: "movimientos",
    component: InformeMovimientosComponent,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class InformesRoutingModule {}
